import React, { useEffect, useState } from 'react';
import { Loader2, RefreshCw, Smartphone } from 'lucide-react';
import api from '@/api/api';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';

const formatDate = (value) => {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString('pt-PT');
  } catch {
    return value;
  }
};

export default function DriverAppView() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      const res = await api.get('/driver-app/sessions');
      setSessions(res.data?.data || []);
    } catch {
      toast.error('Erro ao carregar sessões');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  if (loading) {
    return (
      <div className="p-12 text-center">
        <Loader2 className="mx-auto h-6 w-6 animate-spin text-primary" />
        <p className="mt-3 text-sm text-muted-foreground">Carregando Sessões da App...</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold tracking-tight">PWA Motorista</h1>
        <Button variant="outline" size="sm" onClick={load} disabled={loading}>
          <RefreshCw size={16} className="mr-2" /> Atualizar
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Smartphone size={18} /> Sessões Ativas
          </CardTitle>
        </CardHeader>
        <CardContent>
          {sessions.length === 0 ? (
            <p className="text-sm text-muted-foreground">Nenhuma sessão ativa.</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b text-left text-muted-foreground">
                    <th className="py-2">Motorista</th>
                    <th>Dispositivo</th>
                    <th>IP</th>
                    <th>Login</th>
                    <th>Última atividade</th>
                    <th className="text-right">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {sessions.map((s) => (
                    <tr key={s.id} className="border-b">
                      <td className="py-2 font-medium">{s.driver_name || '—'}</td>
                      <td>{s.device_name || s.device_type || '—'}</td>
                      <td>{s.ip_address || '—'}</td>
                      <td>{formatDate(s.created_at)}</td>
                      <td>{formatDate(s.last_active_at)}</td>
                      <td className="text-right">
                        <span
                          className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${
                            s.is_active ? 'bg-emerald-100 text-emerald-800' : 'bg-muted text-muted-foreground'
                          }`}
                        >
                          {s.is_active ? 'Ativa' : 'Terminada'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
